import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { Element, Section } from 'src/constants/footfall';
import UserLink from 'src/modules/shared/links/userLink';
import RelativeTime from 'src/components/relativeTime';
import Roles from 'src/components/roles';
import { Size } from 'src/components/avatar';
import Separator from 'src/components/separator';
import { titleLarge, textLight } from 'styles-js/mixins/typography';
export default function PollDetails() {
  const {
    title,
    author,
    dateCreated,
    voters
  } = useSelector(state => state.pages.singlePost.post);
  return <Header data-sentry-element="Header" data-sentry-component="PollDetails" data-sentry-source-file="pollDetails.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="pollDetails.tsx">{title}</Title>
      <Row data-sentry-element="Row" data-sentry-source-file="pollDetails.tsx">
        <StyledUserLink avatarSize={Size.Small} signupContext={{
        element: Element.Avatar,
        section: Section.Post
      }} user={author} data-sentry-element="StyledUserLink" data-sentry-source-file="pollDetails.tsx" />
        <StyledUserLink signupContext={{
        element: Element.Avatar,
        section: Section.CommunityPostsPoll
      }} user={author} data-sentry-element="StyledUserLink" data-sentry-source-file="pollDetails.tsx" />
        <Roles roles={author.roles} data-sentry-element="Roles" data-sentry-source-file="pollDetails.tsx" />
        <Separator data-sentry-element="Separator" data-sentry-source-file="pollDetails.tsx" />
        <RelativeTime rawTime={dateCreated} data-sentry-element="RelativeTime" data-sentry-source-file="pollDetails.tsx" />
        <Separator data-sentry-element="Separator" data-sentry-source-file="pollDetails.tsx" />
        {`${voters} ${voters === 1 ? i18n.t('Voter') : i18n.t('Voters')}`}
      </Row>
    </Header>;
}
const Header = styled.div`
  ${textLight};
  margin-bottom: 30px;
`;
const Title = styled.h1`
  ${titleLarge};
  margin-bottom: 10px;
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 8px;
`;
const StyledUserLink = styled(UserLink)`
  color: ${({
  theme
}) => theme.colorTextBlack};
  transition: all 0.5s ease;
  &:hover, &:focus, &:active {
    color: ${({
  theme
}) => theme.colorGreyDark};
  }
`;